export default __webpack_public_path__ + "static/cursor-8663f76b373efdd67882a2d358a3a615.jpg";